export function getUserAvatar(user: any) {
  if (user.avatar_image || user.avatar) {
    return user.avatar_image || user.avatar;
  }

  if (user.gender === "f") {
    return "https://cdn.rc.today/storage/iconlab/general/female.svg";
  }

  return "https://cdn.rc.today/storage/iconlab/general/male.svg";
}
